module.exports = __webpack_public_path__ + "static/image 2-f7e5b07eb234114d36a05417bd2d1035.png";